import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {Observable, ReplaySubject} from "rxjs";
import {Uuid} from "../interface/response/uuid";
import {first} from "rxjs/operators";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {Newsletter} from "../interface/newsletter";
import {ReportFiles} from "../interface/report-files";

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  private readonly reportFilesListSubject: ReplaySubject<CountedAndPaginated<ReportFiles>>
    = new ReplaySubject<CountedAndPaginated<ReportFiles>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  downloadReportOfwcas(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/analytics/ofwca/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }
  downloadReportPartners(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/analytics/partner/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }
  downloadReportContracts(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/analytics/contract/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }
  downloadReportRegistrations(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/analytics/registration/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }
  downloadReportRedirection(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/analytics/commission-redirection/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }
  downloadReportIdentifiers(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/analytics/registration-id/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/reportFiles?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<ReportFiles>) => {
        this.reportFilesListSubject.next(result);
      });
  }
  public getReportFilesListSubject(): ReplaySubject<CountedAndPaginated<ReportFiles>> {
    return this.reportFilesListSubject;
  }
  public downloadFile(uuid: string): void {
    this.document.location.href = `/rest/crm/reportFiles/${uuid}/downloadFile`;
  }

}
